module.exports = __webpack_public_path__ + "img/bingo-base-silabas-inversas.77bbdf3d.png";